import { Agent, AgentScope } from "~/services/agents";
import { useCanManageAIAgents } from "./useCanManageAIAgents";

export const useCanEditAgent = (agent: Agent): boolean => {
  const canManage = useCanManageAIAgents();
  return canManage && agent.scope !== AgentScope.SYSTEM;
};
